// Access gate for `/world`. The world is unreleased, so reaching the route is
// not the same as being allowed in.

import { lazy, Suspense } from 'react';
import { Navigate } from 'react-router';

import { useAuth } from '@/hooks/useAuth';
import CoverLoader from '@/world/ui/CoverLoader';
import { isWorldUnlocked } from './worldAccess';

const WorldPage = lazy(() => import('./WorldPage'));

const WorldLoading = () => (
  <div
    className="flex h-full items-center justify-center bg-neutral-950"
    role="status"
    aria-live="polite"
    aria-busy="true"
  >
    <CoverLoader />
  </div>
);

const WorldRoute = () => {
  const { user, isAuthInitialized } = useAuth();

  // The tier arrives with the user. Deciding before it lands would bounce a
  // permitted visitor off their own hard refresh.
  if (!isAuthInitialized) {
    return <WorldLoading />;
  }

  if (!isWorldUnlocked(user)) {
    return <Navigate to="/library" replace />;
  }

  return (
    <Suspense fallback={<WorldLoading />}>
      <WorldPage />
    </Suspense>
  );
};

export default WorldRoute;
